import { formValueSelector } from 'redux-form';

import { INFERENTIAL_STATISTICS } from '../../names';

const selector = formValueSelector(INFERENTIAL_STATISTICS);

const makeFieldValueGetter = field =>
  state => selector(state, field);

export const getSampleMeanFirst =
  makeFieldValueGetter('twoSampleT.sampleMeanFirst');

export const getStandardDeviationFirst =
  makeFieldValueGetter('twoSampleT.standardDeviationFirst');

export const getSampleSizeFirst =
  makeFieldValueGetter('twoSampleT.sampleSizeFirst');

export const getSampleMeanSecond =
  makeFieldValueGetter('twoSampleT.sampleMeanSecond');

export const getStandardDeviationSecond =
  makeFieldValueGetter('twoSampleT.standardDeviationSecond');

export const getSampleSizeSecond =
  makeFieldValueGetter('twoSampleT.sampleSizeSecond');

export const getNumericalRowDataSetFirst =
  makeFieldValueGetter('twoSampleT.firstVariable');

export const getNumericalRowDataSetSecond =
  makeFieldValueGetter('twoSampleT.secondVariable');
